<section class="users-view">
    <!-- Media object starts -->
    <div class="row">
      <div class="col-12 col-sm-7">
        <div class="media d-flex align-items-center">
          <a href="javascript:;">
            <img
              src="assets/MeanderLIVE-icon.png"
              alt="user view avatar"
              class="users-avatar-shadow rounded"
              height="64"
              width="64"
            />
            <!-- <img
              *ngIf="outsource_data?.image"
              [src]="imageUrl + outsource_data?.image"
              alt="user view avatar"
              class="users-avatar-shadow rounded"
              height="64"
              width="64"
            /> -->
          </a>
          <div class="media-body ml-3">
            <h4>
              <span class="users-view-name mr-1">{{
                outsource_data?.leads?.title
              }}</span>
              <!-- <span class="text-muted font-medium-1">
                    <span>@</span>
                    <span class="users-view-username">dean3004</span>
                  </span> -->
            </h4>
            <!-- <span class="mr-1">ID :</span>
            <span class="users-view-id">{{
              outsource_data?._id.substring(outsource_data?._id.length - 6)
            }}</span> -->
          </div>
        </div>
      </div>
      <div class="col-12 col-sm-5 d-flex justify-content-end align-items-center">
        <!-- <a
          href="javaScript:void(0);"
          class="btn btn-sm bg-light-secondary mr-2 px-3 py-1"
          ><i class="ft-mail"></i
        ></a>
        <a
          href="javaScript:void(0);"
          class="btn btn-sm bg-light-secondary mr-2 px-3 py-1"
          >Profile</a
        > -->
        <!-- <a
          class="btn btn-sm btn-primary px-3 py-1"
          (click)="">Edit</a
        > -->
      </div>
    </div>
    <!-- Media object ends -->
  
    <div class="row">
      <div class="col-12">
        <!-- Card data starts -->
        <div class="card">
          <div class="card-content">
            <div class="card-body">
              <div class="row">
                <div class="col-12 col-xl-10">
                  <h5 class="mb-2 text-bold-500">
                    <i class="ft-info mr-2"></i> Lead Info
                  </h5>
                  <table class="table table-borderless">
                    <tbody>
                      <tr>
                        <td>Title :</td>
                        <td><b>{{ outsource_data?.leads?.title }}</b></td>
                      </tr>
                      <tr *ngIf="outsource_data?.coverletter">
                        <td style="width: 100px;">Cover Letter :</td>
                        <td>
                          <p   [innerText]="outsource_data?.coverletter"></p>

                        </td>
                      </tr>
                      <tr *ngIf="outsource_data?._id">
                        <td>ID :</td>
                        <td>
                          {{ outsource_data?._id }}
                        </td>
                      </tr>
                      <tr>
                        <td>Date :</td>
                        <td>
                          {{ outsource_data?.date}}
                        </td>
                      </tr>
                      <tr>
                        <td>Lead Type :</td>
                        <td>{{ outsource_data?.outsource?.displayname }}</td>
                      </tr>
                      <tr>
                        <td>Lead Stage :</td>
                        <td>
                          {{ outsource_data?.leads?.lead_stage?.displayname}}
                        </td>
                      </tr>
                      <tr>
                        <td>Lead Status :</td>
                        <td>{{ outsource_data?.leads?.lead_status?.displayname }}</td>
                      </tr>
                      <tr>
                        <td>Next Action :</td>
                        <td>{{ outsource_data?.leads?.next_action?.displayname }}</td>
                      </tr>
                      <tr>
                        <td>Lead Source :</td>
                        <td>{{ outsource_data?.leads?.source?.displayname }}</td>
                      </tr>
                      <tr>
                        <td>Channel :</td>
                        <td>{{ outsource_data?.channelId?.name }}</td>
                      </tr>
                      <tr>
                        <td>Link :</td>
                        <td><a [href]="outsource_data?.links" target="_blank">{{ outsource_data?.links }}</a></td>
                      </tr>
                      <tr *ngIf="outsource_data?.leads?.lastresponse">
                        <td>Last Response :</td>
                        <td>{{ outsource_data?.leads?.lastresponse }}</td>
                      </tr>
                      <tr>
                        <td>Last Active Date :</td>
                        <td>{{ outsource_data?.leads?.last_activedate | date:'mediumDate'}}</td>
                      </tr>
                      <tr>
                        <td>Name :</td>
                        <td>{{ outsource_data?.contact?.name}}</td>
                      </tr>
                      <tr>
                        <td>Email :</td>
                        <td>{{ outsource_data?.contact?.email}}</td>
                      </tr>
                      <tr>
                        <td>Phone :</td>
                        <td>{{ outsource_data?.contact?.phone}}</td>
                      </tr>
                      <tr>
                        <td>Notes :</td>
                        <td>{{ outsource_data?.notes }}</td>
                      </tr>
                      <tr *ngIf="outsource_data?.admin_notes">
                        <td>Admin Notes :</td>
                        <td>{{ outsource_data?.admin_notes }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Card data ends -->
        <!-- platform info -->
        <div class="card">
            <div class="card-content">
              <div class="card-body">
                <div class="row">
                  <div class="col-12 col-xl-4">
                    <h5 class="mb-2 text-bold-500">
                      <i class="ft-info mr-2"></i> Platform Info
                    </h5>
                    <table class="table table-borderless">
                      <tbody>
                        <tr>
                            <td>Browser :</td>
                            <td>{{outsource_data?.leads?.platform }}</td>
                        </tr>
                        <!-- <tr>
                            <td>Device Type :</td>
                            <td>{{outsource_data?.leads?.deviceType }}</td>
                        </tr> -->
                        <tr *ngIf="outsource_data?.leads?.ip">
                          <td>Ip Address :</td>
                          <td><a [href]="'https://www.ip2location.com/demo/'+outsource_data?.leads?.ip" target="_blank">{{outsource_data?.leads?.ip }}</a></td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
        </div>
        <!-- end -->
      </div>
    </div>
    <div _ngcontent-fdm-c126="" class="buy-now">
      <a _ngcontent-fdm-c126="" routerLink="/leads/outsource-leads"  class="btn btn-danger">Back To Outsource Leads</a>
    </div>
  </section>
  